import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Link from 'components/shared/link';
import Switch from 'components/shared/switch';

import styles from './settings-item.module.scss';

const cx = classNames.bind(styles);

const SettingsItem = (props) => {
  const { title, description, linkName, linkURL, isChecked, isDisabled, onChange } = props;

  return (
    <div className={cx('wrapper')}>
      <Switch isChecked={isChecked} isDisabled={isDisabled} onChange={onChange} />
      <div className={cx('inner')}>
        <h3 className={cx('name')}>{title}</h3>
        <p className={cx('text')}>{description}</p>
        <Link className={cx('link')} to={linkURL} target="_blank" rel="noreferrer">
          {linkName}
        </Link>
      </div>
    </div>
  );
};

SettingsItem.defaultProps = {
  isDisabled: false,
  onChange: null,
};

SettingsItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  linkName: PropTypes.string.isRequired,
  linkURL: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default SettingsItem;
